import styled from "styled-components"
import { Container } from "components/styled/Grid"
import { mq } from "helpers/styled"

export const ReviewsSection = styled.div`
  padding: 50px 0;
  background-color: ${({ theme }) => theme.colors.paleGray};
`

export const ReviewCard = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  display: flex;
  flex-direction: column;
  height: 100%;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.1);
  }
`

export const ReviewHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`

export const AuthorImage = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 12px;
`

export const AuthorName = styled.span`
  font-weight: ${({ theme }) => theme.weights.bold};
  color: ${({ theme }) => theme.colors.darkBlue};
  font-size: 16px;
`

export const ReviewDate = styled.span`
  color: ${({ theme }) => theme.colors.dimGray};
  font-size: 12px;
  margin-top: auto;
  padding-top: 16px;
`

export const ReviewText = styled.p`
  color: ${({ theme }) => theme.colors.dimGray};
  font-size: 14px;
  line-height: 1.6;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const StarRating = styled.div`
  display: flex;
  gap: 2px;
`

export const StarIcon = styled.span`
  color: ${({ theme }) => theme.colors.yellow};
  font-size: 14px;
`

export const HeaderContainer = styled.div`
  text-align: center;
  margin-bottom: 30px;
`

export const SliderWrapper = styled(Container)`
  position: relative;
  margin-left: auto;
  margin-right: auto;
`

export const SliderTrack = styled.div`
  display: flex;
  align-items: stretch;
  padding-bottom: 25px;
`

export const Slide = styled.div`
  flex: 0 0 85%;
  min-width: 0;
  padding: 0 10px;

  @media ${mq("lg")} {
    flex: 0 0 33.333%;
  }

  @media ${mq("xl")} {
    flex: 0 0 33.333%;
  }
`

export const ControlsContainer = styled.div`
  display: none;

  @media ${mq("lg")} {
    display: block;
  }
`
